type Child = Node | string | null | undefined | false;
type Attrs = Record<string, string | boolean | ((e: Event) => void) | undefined>;

/**
 * Build an element. Strings become text nodes, never HTML, so nothing a person or the API sends
 * can inject markup. Attributes named on* take a function and add a listener.
 */
export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false) continue;
    if (typeof v === 'function') el.addEventListener(k.replace(/^on/, ''), v);
    else if (v === true) el.setAttribute(k, '');
    else el.setAttribute(k, v);
  }
  for (const c of children) if (c) el.append(c);
  return el;
}

export function clear(el: Element): void {
  while (el.firstChild) el.removeChild(el.firstChild);
}

/** A labelled field: <label>Text <input></label>, so the label is the accessible name. */
export function field(label: string, input: HTMLElement): HTMLElement {
  return h('label', { class: 'field' }, h('span', { class: 'lbl' }, label), input);
}

export const alertBox = (msg: string) => h('p', { role: 'alert', class: 'err' }, msg);
export const statusBox = (msg: string) => h('p', { role: 'status', class: 'ok' }, msg);
